export class QATicketNotification {
    FeedBack: string;
    GCTicketNumber: string;
    Status: string;
    TicketID: number;
    ID: number;
    SentTo: string;
    CreatedBy: string;
    Creation: Date;
    GCTicketID: string;
}
export class NotificationDeliveryStatus {
    IsDelivered: boolean;
    TicketID: number;
    SentTo: string;
    GCTicketNumber: string;
    CreatedBy: string;
    Creation: Date;
}

export class NotificationEmailList {
    ID: number;
    EmailAddress: string;
    QueueCategory: string;
    Name: string;
    Creation: Date;
    CriticalLevel: number;
}
